import type { RailLayout } from "@/data/rail-branches";
import type { SceneBeat } from "@/lib/timeline/book/BookLayout";
import { buildLocationRuns, type LocationRun } from "../LocationRun/runs";
import { layoutSpreadLocationBoxes } from "./spread";
import type {
  LocationBoxPlacement,
  LocationLayoutView,
} from "./types";

export type { LocationBoxPlacement, LocationLayoutView } from "./types";
export {
  sceneStartMarkerCenterX,
  timelineLocationBoxTopY,
} from "./metrics";

/** Fixed positions along the rail (time-based); not tied to camera zoom. */
export function layoutLocationBoxes(
  beats: SceneBeat[],
  playheadMs: number,
  viewportWidth: number,
  totalDurationMs: number,
  _view?: LocationLayoutView,
  runs: LocationRun[] = buildLocationRuns(beats),
  rail?: RailLayout,
): LocationBoxPlacement[] {
  if (runs.length === 0) {
    return [];
  }
  return layoutSpreadLocationBoxes(
    runs,
    playheadMs,
    viewportWidth,
    totalDurationMs,
    rail,
  );
}
